import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

import {BehaviorSubject, Subject} from 'rxjs';

import * as fromModuleModels from '../../models';
import {ErrorsObject} from '../../../shared/utilities/error-utility.utility';
import {FormsService} from '../../../shared/services';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'operating-system-form',
  styleUrls: ['operating-system-form.component.scss'],
  template: `

    <div class="card mat-elevation-z1">

      <div class="card__heading">
        <span>{{ presets$.getValue() ? 'Betriebssystem bearbeiten' : 'Neues Betriebssystem anlegen' }}</span>
      </div>

      <div class="card__content">
        <form [formGroup]="osf" (ngSubmit)="handleSubmit()">

          <div class="grid">
            <div class="column-11">
              <mat-form-field>
                <mat-label>Name</mat-label>
                <input type="text" matInput formControlName="name" required>
                <mat-hint align="start" *ngIf="errors?.name">{{ errors.name.message }}</mat-hint>
              </mat-form-field>
            </div>

            <div class="column-3">
              <mat-slide-toggle formControlName="isActive" [checked]="true">Aktiv</mat-slide-toggle>
            </div>

            <div class="m-ta--2 column-14">

              <button *ngIf="presets$.getValue() || osf.dirty" class="m-r--16" (click)="cancelEdit()" type="button"
                      color="outline" mat-flat-button>
                <mat-icon class="m-r--8">cancel</mat-icon>
                <span>Abbrechen</span>
              </button>

              <button [disabled]="osf.invalid || osf.untouched" mat-flat-button color="green">
                <mat-icon class="m-r--8">save</mat-icon>
                <span>{{ presets$.getValue() ? 'Aktualisieren' : 'Anlegen' }}</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  `
})
export class OperatingSystemFormComponent implements OnInit {

  @Input()
  errors: ErrorsObject;

  @Input()
  presets$: BehaviorSubject<any>;

  @Output()
  requestCreateItem: EventEmitter<{ payload: fromModuleModels.OperatingSystem, entity: string }>
    = new EventEmitter<{ payload: fromModuleModels.OperatingSystem, entity: string }>();

  @Output()
  requestUpdateItem: EventEmitter<{ iri: string, payload: fromModuleModels.OperatingSystem, entity: string }>
    = new EventEmitter<{ iri: string, payload: fromModuleModels.OperatingSystem, entity: string }>();

  onDestroy$: Subject<any> = new Subject<any>();

  osf: FormGroup;

  constructor(private fb: FormBuilder, private fs: FormsService) {
  }

  ngOnInit(): void {
    this.presets$.pipe(
      takeUntil(this.onDestroy$),
    ).subscribe(preset => {
      this.initForm();
      this.fs.patchForm(this.osf, preset);
      this.osf.markAsUntouched();
    });
  }

  initForm() {
    this.osf = this.fb.group({
      name: this.fb.control(null, [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      isActive: this.fb.control(false, [Validators.required])
    });
  }

  cancelEdit() {
    this.initForm();
    this.presets$.next(null);
  }

  handleSubmit(): void {

    const payload: fromModuleModels.OperatingSystem = this.osf.value;

    !this.presets$.getValue()
      ? this.requestCreateItem.emit({payload, entity: 'OperatingSystem'})
      : this.requestUpdateItem.emit({iri: this.presets$.getValue()['@id'], payload, entity: 'OperatingSystem'});
  }
}
